// @flow

import React from "react";
import { connect } from "react-redux";
import { PageLayout, PageHeader } from "buba-components";
import { saveUserData } from "../../store/user/actions";
import paths from "../../data/paths";

import styles from "./SsoCallback.scss";

type Props = {
  saveUserData: (token: string, email: string, passwordExpired: boolean) => void,
  history: {
    replace: (path: string) => void
  }
};

type State = {
  error: ?string
};

class SsoCallback extends React.Component<Props, State> {
  state = {
    error: null
  };

  componentDidMount() {
    this.handleCallback();
  }

  handleCallback = () => {
    const { saveUserData: saveUserDataAction, history } = this.props;

    const params = new URLSearchParams(window.location.hash.slice(1));
    const accessToken = params.get("access_token");
    const userEmail = params.get("user_email") || "";

    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    if (!accessToken) {
      this.setState({ error: "Authentifizierung fehlgeschlagen" });
      return;
    }

    saveUserDataAction(accessToken, userEmail, false);
    history.replace(paths.bankInquiriesListNew);
  };

  render() {
    const { error } = this.state;

    if (error) {
      return (
        <PageLayout>
          <PageHeader header="Fehler" bottomMargin />
          <p className={styles.message}>{error}</p>
        </PageLayout>
      );
    }

    return (
      <PageLayout>
        <p className={styles.message}>Authentifizierung...</p>
      </PageLayout>
    );
  }
}

export default connect(null, { saveUserData })(SsoCallback);
